import React from "react";
import { Field, ConfigInput } from "./Field";

export default function WebhookFields({ config, setConfig }) {
  return (
    <>
      <Field label="Webhook URL" required colSpan={2}>
        <ConfigInput name="url" config={config} setConfig={setConfig} testId="dest-url" required
          placeholder="https://api.example.com/leads/webhook" mono={false} />
      </Field>
      <Field label="Method">
        <select className="w-full border border-black px-2 py-1.5 mt-1"
          value={config.method || "POST"} onChange={(e) => setConfig("method", e.target.value)}>
          {["POST", "PUT"].map((m) => <option key={m} value={m}>{m}</option>)}
        </select>
      </Field>
      <Field label="HMAC secret (optional)">
        <ConfigInput name="secret" config={config} setConfig={setConfig} testId="dest-secret"
          placeholder="Used to sign X-LeadFlow-Signature header" />
      </Field>
      <Field label="Also count these replies as a rejection (optional)" colSpan={2}>
        <ConfigInput name="reject_words" config={config} setConfig={setConfig} testId="dest-reject-words"
          placeholder="e.g. not accepted, cap reached, sold" mono={false} />
        <div className="mt-1 text-[10px] leading-relaxed text-zinc-500">
          We already spot rejected, duplicate, declined, denied and failed in the buyer&apos;s reply. Separate extra words with commas.
          A rejected lead is retried like any failed delivery.
        </div>
      </Field>
    </>
  );
}
